import _extends from "@babel/runtime-corejs3/helpers/extends";
import { noop as _$no, createElementVNode as _$ce, className as _$cn, createUnknownComponentVNode as _$cc, createVNode as _$cv } from 'intact-react';
import { DropdownMenu } from '../dropdown';
import { getRestProps, findChildren, isComponentVNode } from '../utils';
import { isDropdown } from './useDropdown';
import { makeMenuStyles, makeTitleStyles } from './styles';
import { Icon } from '../icon';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj, _$cn2;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className;
  var _get = (this.rootMenu || this).get(),
    collapse = _get.collapse,
    theme = _get.theme,
    type = _get.type,
    size = _get.size,
    showCollapseArrow = _get.showCollapseArrow;
  var isRootMenu = !this.rootMenu;
  var isDropdownMenu = !isRootMenu && isDropdown(this.rootMenu);
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-menu"] = true, _classNameObj[className] = className, _classNameObj[k + "-" + (theme === 'dark' ? 'dark' : 'light')] = (isRootMenu || isDropdownMenu) && theme, _classNameObj[k + "-" + size] = isRootMenu && size !== 'default', _classNameObj[k + "-collapsed"] = isRootMenu && collapse, _classNameObj[k + "-collapsed-arrow"] = isRootMenu && showCollapseArrow && collapse, _classNameObj[k + "-" + type] = isRootMenu && type, _classNameObj[makeMenuStyles(k)] = true, _classNameObj);
  var header = (_$blocks['header'] = function ($super) {
    return null;
  }, __$blocks['header'] = function ($super, data) {
    var block = $blocks['header'];
    var callBlock = function callBlock() {
      return _$blocks['header'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['header'](_$no));
  var content = [$blocks.header ? _$ce(2, 'div', !collapse ? header : findChildren(header, function (vNode) {
    return isComponentVNode(vNode, Icon);
  }), 0, _$cn((_$cn2 = {}, _$cn2[k + "-menu-header"] = true, _$cn2[makeTitleStyles(k)] = true, _$cn2))) : undefined, isRootMenu && showCollapseArrow && type !== 'horizontal' ? _$ce(2, 'div', _$cc(Icon, {
    'className': _$cn(k + "-menu-arrow ion-arrow-left-b")
  }), 2, _$cn(k + "-menu-arrow-box"), {
    'ev-click': this.onClick.bind(this)
  }) : undefined, _$ce(2, 'div', children, 0, _$cn(k + "-menu-body"))];
  return !isDropdownMenu ? _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj)
  }), content) : _$cc(DropdownMenu, _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj),
    'children': content
  }));
}
;